// frontend\src\App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import PrivateRoute from "./components/PrivateRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Login from "./pages/Login";
import Register from "./pages/Register";
import DevChart from "./pages/DevChart";
import AboutPage from "./pages/AboutPage";
import Calculators from "./pages/Calculators";
import ScanCatalog from "./pages/ScanCatalog";
import ScanRecord from "./pages/ScanRecord";
import MyFilms from "./pages/MyFilms";
import FilmForm from "./pages/FilmForm";
import Profile from "./pages/Profile";
import DevTimerSetup from "./pages/DevTimerSetup";
import DevTimer from "./pages/DevTimer";
import Chemicals from "./pages/Chemicals";
import ChemicalForm from "./pages/ChemicalForm";
import Favorites from "./pages/Favorites";

import "./styles/theme.css";

const App = () => {
  return (
    <ThemeProvider> 
      <Router>
        <AuthProvider>
          <div className="d-flex flex-column min-vh-100">
            <Navbar />
            <div className="flex-grow-1">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/timer-setup" element={<DevTimerSetup />} />
                <Route path="/timer" element={<DevTimer />} />
                <Route path="/calc" element={<Calculators />} />
                <Route path="/about" element={<AboutPage />} />

                {/* Protected routes */}
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<DevChart />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/catalog" element={<ScanCatalog />} />
                  <Route path="/catalog/new" element={<ScanRecord />} />
                  <Route path="/catalog/edit/:id" element={<ScanRecord />} />
                  <Route path="/films" element={<MyFilms />} />
                  <Route path="/films/new" element={<FilmForm />} />
                  <Route path="/films/edit/:id" element={<FilmForm />} />
                  <Route path="/chemicals" element={<Chemicals />} />
                  <Route path="/chemicals/new" element={<ChemicalForm />} />
                  <Route path="/chemicals/edit/:id" element={<ChemicalForm />} />
                  <Route path="/profile" element={<Profile />} />
                </Route>
              </Routes>
            </div>
            <Footer />
          </div>
          <ToastContainer />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;